import { useEffect } from 'react';
import { AppTheme } from '@meitu/saas-ui/es/theme';
import { useFeatureHelper } from '@/hooks/use-feature-helper';
import { editor } from '@/instance';
import { ImagePanelFeatureType } from '@/types';
import { IImgPanelType } from '../../type';

interface IEnhanceOperate {
    onSlider?: (type: string, val: number) => void;
    onReset?: () => void;
    onSelect?: (index: number, type?: string) => void;
    onTab?: (type: string) => void;
}

/**
 * 滑动条功能
 *
 * @param param0 - 参数
 */
export const useEnhanceOperateHelper = ({ onSlider, onReset, onSelect, onTab }: IEnhanceOperate) => {
    const onAfterEnhanceHandle = (type: string, val: number) => {
        onSlider?.(type, val);
    };

    const onResetHandle = () => {
        onReset?.();
    };

    const onSelectHandle = (index: number, type?: string) => {
        onSelect?.(index, type);
    };

    const onTabHandle = (type: string) => {
        onTab?.(type);
    };

    return {
        theme: editor.getTheme() as AppTheme,
        onAfterEnhance: onAfterEnhanceHandle,
        onReset: onResetHandle,
        onSelect: onSelectHandle,
        onTab: onTabHandle,
    };
};

/**
 * 菜单组件属性
 *
 * @param featureType - 特性
 * @param setCurType - 当前类型
 * @param clickCallback - 点击回调处理方法
 */
export const useCardMenuHelper = (
    featureType: ImagePanelFeatureType,
    setCurType: Function,
    clickCallback: Function,
) => {
    return {
        onShowChange(checked: boolean) {
            if (checked) {
                setCurType(featureType);
            } else {
                setCurType(ImagePanelFeatureType.ADJUST_BASE);
            }
            clickCallback(checked);
        },
    };
};

export const useEnhanceEventsHelper = (
    featureType: IImgPanelType,
    curType: ImagePanelFeatureType | '',
    layerId: string,
) => {
    const { register } = useFeatureHelper();
    const { imageEnhance } = editor;

    useEffect(() => {
        if (!layerId) return;

        const layer = editor.stage.getLayer(layerId);

        register(featureType, {
            enter() {
                console.log('===>enter', { featureType });
                editor.history.setRedoUndo(false);
                editor.disableBasicOperate({ move: true, resize: true, rotate: true, scale: true });

                setTimeout(async () => {
                    await imageEnhance.basicEnhance.create(layer);
                }, 0);
            },
            leave() {
                console.log('===>leave', { featureType });
                editor.tip.showMask({
                    loading: true,
                });
                setTimeout(async () => {
                    await imageEnhance.basicEnhance.applyConfirm();
                    editor.tip.hideMask();
                    editor.history.setRedoUndo(true);
                    editor.enableBasicOperate({ move: true, resize: true, rotate: true, scale: true });
                }, 0);
            },
        });
    }, [layerId]);

    useEffect(() => {
        // HSL 重新取色
        if (curType === ImagePanelFeatureType.ADJUST_HSL) {
            imageEnhance.extractColors();
        }
    }, [curType]);
};
